module.exports = __webpack_public_path__ + "static/img/ai审核_产品截图1@2x.d32ec19f.png";